import * as Yup from "yup";

export interface SelectOption {
  value: string;
  label: string;
}

export const statusOptions: SelectOption[] = [
  { label: "Active", value: "ACTIVE" },
  { label: "Inactive", value: "INACTIVE" },
  { label: "Repair", value: "REPAIR" },
  { label: "Rental", value: "RENTAL" },
  { label: "Out Of Service", value: "OUT OF SERVICE" }
];

export interface EquipmentDetailModel {
  id: string | null;
  unitNumber: string | null;
  equipmentType: string | null;
  assetDescriptor: string | null;
  make: string | null;
  model: string | null;
  year: string | null;
  vin: string | null;
  licensePlate: string | null;
  registrationDate: string | null;
  dotInspectionDate: string | null;
  domicileTerminal: string | null;
  location: string | null;
  garageCity: string | null;
  garageState: string | null;
  status: string | null;
  disposition: string | null;
  utilizationPercent: string | null;
  dwellTimeDays: string | null;
  leaseType: string | null;
  vendor: string | null;
  productLine: string | null;
  termMonths: string | null;
  annualAllowance: string | null;
  annualRateMeasurement: string | null;
  monthlyRate: string | null;
  size: string | null;
  accessory: string | null;
  serialNumber: string | null;
  inServiceDate: string | null;
  expirationDate: string | null;
  fuelType: string | null;
  registrationDocUrl: string | null;
  dotCertificateUrl: string | null;
  notes: string | null;
}
export interface EquipmentFormModel {
  id: string | null;
  unitNumber: string | null;
  equipmentType: string | null;
  assetDescriptor: string | null;
  make: string | null;
  model: string | null;
  year: string | null;
  vin: string | null;
  licensePlate: string | null;
  registrationDate: string | null;
  dotInspectionDate: string | null;
  domicileTerminal: string | null;
  location: string | null;
  garageCity: string | null;
  garageState: string | null;
  status: string | null;
  disposition: string | null;
  utilizationPercent: string | null;
  dwellTimeDays: string | null;
  leaseType: string | null;
  vendor: string | null;
  productLine: string | null;
  termMonths: string | null;
  annualAllowance: string | null;
  annualRateMeasurement: string | null;
  monthlyRate: string | null;
  size: string | null;
  accessory: string | null;
  serialNumber: string | null;
  inServiceDate: string | null;
  expirationDate: string | null;
  fuelType: string | null;
  registrationDocUrl: string | null;
  dotCertificateUrl: string | null;
  notes: string | null;
}

export const getEquipmentInfoValidation = (): Yup.ObjectSchema<EquipmentFormModel> => {

  return Yup.object().shape({
    unitNumber: Yup.string().required('Unit Number is required'),
    equipmentType: Yup.string().required('Equipment Type is required'),
    assetDescriptor: Yup.string().required('Asset Descriptor is required'),
    make: Yup.string().required('Make is required'),
    model: Yup.string().required('Model is required'),
    year: Yup.string()
      .required('Year is required')
      .matches(/^(19|20)\d{2}$/, 'Year must be a valid 4-digit year'),
    vin: Yup.string().required('VIN is required'),

    licensePlate: Yup.string().required('License Plate is required').max(200, 'Too long'),
    registrationDate: Yup.string().nullable().required('Registration Date is required'),
    dotInspectionDate: Yup.string().nullable().required('DOT Inspection Date is required'),

    location: Yup.string().required('Terminal is required'),
    status: Yup.string().required('Service Status is required'),

    leaseType: Yup.string().required('Lease Type is required'),
    vendor: Yup.string().required('Vendor is required'),

    notes: Yup.string().nullable().max(1000, 'Notes cannot exceed 1000 characters'),

  }).defined();
};